var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid p-0 px-3 mx-auto" },
    _vm._l(_vm.proposalDocuments, function(document, index) {
      return _c(
        "custom-callout",
        {
          key: `proposal-document-${index}`,
          staticClass: "custom-callout my-3 px-1"
        },
        [
          _c("div", { staticClass: "row mx-auto p-3" }, [
            _c("div", { staticClass: "col-12 col-md-4" }, [
              _c("div", { staticClass: "font-14 color-gray-6" }, [
                _vm._v(" Documento: ")
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "font-14 color-black d-flex align-align-items-center"
                },
                [
                  _c("span", { staticClass: "color-black font-16 mr-3" }, [
                    _vm._v(" " + _vm._s(_vm.documentTypeName(document)) + " ")
                  ])
                ]
              )
            ]),
            _c("div", { staticClass: "col-12 col-md-4" }, [
              _c("div", { staticClass: "font-14 color-gray-6" }, [
                _vm._v(" Archivo: ")
              ]),
              _c(
                "div",
                {
                  staticClass:
                    "font-14 color-black d-flex align-align-items-center"
                },
                [
                  _c("span", { staticClass: "color-black font-16 mr-3" }, [
                    _vm._v(" " + _vm._s(_vm.documentFilename(document)) + " ")
                  ])
                ]
              )
            ]),
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-md-4 d-flex justify-content-end align-items-center"
              },
              [
                _c("action-button", {
                  attrs: { i: "fas fa-file-download", variant: "success" },
                  on: {
                    click: function($event) {
                      return _vm.onDownload(document)
                    }
                  }
                })
              ],
              1
            )
          ])
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }